module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[64]551.728bcfc.woff2";